import { SisetuResult } from "interface/sisetu"
import { KojinResult } from "interface/kojin"

export type MatchingState =
  | "match"
  | "multiHit"
  | "maybe"
  | "unable"
  | "notFound"
  | "wait"
	| "memo"

export const matchingScoreToState = (score: number | null | undefined, isMultiHit: boolean) => {
  if (score) {
    if (score === 100) {
      return isMultiHit ? "multiHit" : "match"
    }
    if (score >= 60) return "maybe"
    return "unable"
  }
  return "notFound"
}

export type MatchingCondition = {
  target: 'kojin' | 'sisetu'
  searchWords: string
  senmon: string
}

export type MatchingResultData = {
  dcfCode: string | null
  sisetu?: SisetuResult
  kojin?: KojinResult
  candidates: SisetuResult[] | KojinResult[]
  isMultiHit: boolean
  state?: MatchingState
}
